import * as React from "react";

function IconCheckmarkCircle({ color = "#7BDC81", checkMarkColor = "#000", ...props }) {
  return (
    <svg width={16} height={16} fill="none" {...props}>
      <circle cx={8} cy={8} r={7.75} fill={color} stroke={color} strokeWidth={0.5} />
      <path
        d="M6.6 10.2l-2-2a.7.7 0 1 1 1-1l1.5 1.5 3.3-3.3a.7.7 0 1 1 1 1l-3.8 3.8z"
        fill={checkMarkColor}
      />
    </svg>
  );
}

const MemoIconCheckmarkCircle = React.memo(IconCheckmarkCircle);
export default MemoIconCheckmarkCircle;
